import React from "react";
import { useNavigate } from "react-router-dom";

const LoginButton = () => {
    const navigate = useNavigate();

    const handleLogin = () => {
        const currentPath = window.location.pathname + window.location.search;
        navigate(`/login?redirect=${encodeURIComponent(currentPath)}`);
    };

    return (
        <button
            onClick={handleLogin}
            className="inline-flex items-center justify-center h-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-md shadow-md"
        >
            Iniciar sesión
        </button>
    );
};

export default LoginButton;
